/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosDelegationNodeListInfo } from '../models/AptosDelegationNodeListInfo';
import type { AptosDelegationNodeListRequest } from '../models/AptosDelegationNodeListRequest';
import type { AptosNodeAddressRequest } from '../models/AptosNodeAddressRequest';
import type { AptosNodeDetailInfo } from '../models/AptosNodeDetailInfo';
import type { AptosNodeListInfo } from '../models/AptosNodeListInfo';
import type { AptosNodeListRequest } from '../models/AptosNodeListRequest';
import type { AptosNodeLocationListInfo } from '../models/AptosNodeLocationListInfo';
import type { AptosNodeSummaryInfo } from '../models/AptosNodeSummaryInfo';
import type { NodeRequest } from '../models/NodeRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class NodeControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNodeDetail({
        requestBody,
    }: {
        requestBody: AptosNodeAddressRequest,
    }): CancelablePromise<AptosNodeDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/node',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNodeSummary({
        requestBody,
    }: {
        requestBody: NodeRequest,
    }): CancelablePromise<AptosNodeSummaryInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/node/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNodeLocationList({
        requestBody,
    }: {
        requestBody: NodeRequest,
    }): CancelablePromise<AptosNodeLocationListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/node/location/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNodeList({
        requestBody,
    }: {
        requestBody: AptosNodeListRequest,
    }): CancelablePromise<AptosNodeListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/node/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getDelegationNodeList({
        requestBody,
    }: {
        requestBody: AptosDelegationNodeListRequest,
    }): CancelablePromise<AptosDelegationNodeListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/node/delegation/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
